<template>
  <button class="back-button" @click.stop="goBack">
    <inline-svg src="/images/icons/chevron-left-solid.svg"></inline-svg>
  </button>
</template>

<script>
/**
 * Back button component that can either double as the browser's back button or as botton firing a `back` event
 */
export default {
  name: 'BackButton',
  props: {
    routerNavigation: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goBack() {
      if (this.routerNavigation) {
        this.$router.back()
      } else {
        this.$emit('back')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back-button {
  position: relative;
  width: 20px;
  height: 20px;
  padding: 0;
  margin-right: 4px;

  svg {
    width: 20px;
    height: 20px;

    path,
    rect {
      fill: var(--sub-color);
    }
  }
}
</style>
